import { formAtom } from "@frontend/lib/form";

import { interlocutorSchema } from "../schemas";
import type { InterlocutorValues } from "../schemas";

const empty: InterlocutorValues = { personId: null, typeId: null };

/** One form serves every list: each opening starts it over on its own line. */
export const interlocutorForm = formAtom(interlocutorSchema, empty);
